import React, { useEffect, useState } from 'react';
import styles from './Styles/Users.module.css';
import { getAllPhotographers, updatePhotographer } from '../../Services/arndAPI';
import Loader from '../../Components/Loader/Loader';

export default function Photographers() {
  const [photographers, setPhotographers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ fullName: '', email: '', phoneNumber: '' });

  const fetchPhotographers = async () => {
    setLoading(true);
    setStatus('');
    try {
      const data = await getAllPhotographers();
      setPhotographers(data);
    } catch {
      setStatus('Error loading photographers.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPhotographers();
  }, []);

  const handleEdit = (p) => {
    setEditingId(p.id);
    setEditForm({
      fullName: p.fullName || '',
      email: p.email || '',
      phoneNumber: p.phoneNumber || '',
    });
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async (e, id) => {
    e.preventDefault();
    setStatus('Updating...');
    try {
      await updatePhotographer(id, editForm);
      setStatus('Photographer updated.');
      setEditingId(null);
      fetchPhotographers();
    } catch {
      setStatus('Error updating photographer.');
    }
  };

  const handleCancel = () => {
    setEditingId(null);
  };

  return (
    <div className={styles.container}>
      <h2>Manage Photographers</h2>
      {loading ? (
        <Loader />
      ) : (
        <div className={styles.cardGrid}>
          {photographers.map((p) => (
            <div key={p.id} className={styles.userCard}>
              {editingId === p.id ? (
                <form onSubmit={(e) => handleUpdate(e, p.id)} className={styles.editForm}>
                  <label>
                    Full Name:
                    <input
                      type="text"
                      name="fullName"
                      value={editForm.fullName}
                      onChange={handleEditFormChange}
                    />
                  </label>
                  <label>
                    Email:
                    <input
                      type="email"
                      name="email"
                      value={editForm.email}
                      onChange={handleEditFormChange}
                    />
                  </label>
                  <label>
                    Phone:
                    <input
                      type="text"
                      name="phoneNumber"
                      value={editForm.phoneNumber}
                      onChange={handleEditFormChange}
                    />
                  </label>
                  <div style={{ marginTop: '1rem' }}>
                    <button type="submit" className={styles.saveBtn}>Save</button>
                    <button type="button" className={styles.cancelBtn} onClick={handleCancel} style={{ marginLeft: 8 }}>Cancel</button>
                  </div>
                </form>
              ) : (
                <>
                  <div className={styles.cardHeader}>
                    <h3>{p.fullName || 'No Name'}</h3>
                    <span className={`${styles.roleBadge} ${styles['photographer']}`}>Photographer</span>
                  </div>
                  <p><strong>ID:</strong> {p.id}</p>
                  <p><strong>Email:</strong> {p.email}</p>
                  <p><strong>Phone:</strong> {p.phoneNumber || 'N/A'}</p>
                  <p><strong>Profile Set:</strong> {p.profileIsSet ? '✅' : '❌'}</p>
                  <p><strong>Created:</strong> {new Date(p.createdAt).toLocaleDateString()}</p>
                  <div>
                    <strong>Events:</strong>
                    {p.Events?.length ? (
                      <ul>
                        {p.Events.map(ev => <li key={ev.id}>{ev.name} ({new Date(ev.date).toLocaleDateString()})</li>)}
                      </ul>
                    ) : <span>None</span>}
                  </div>
                  <button className={styles.editBtn} style={{ marginTop: 8 }} onClick={() => handleEdit(p)}>Edit</button>
                </>
              )}
            </div>
          ))}
        </div>
      )}
      {status && <div className={styles.status}>{status}</div>}
    </div>
  );
}
